import React from "react";
import Fade from "react-reveal/Fade";
import { transformErrorMessage } from "../../helpers";
const ErrorContainer = ({
  errors = [],
  name = "",
  message,
  extraString = "",
  extraTo = "",
}) => {
  return (
    <Fade
      right
      collapse
      when={message || (errors && errors?.[name]?.message) ? true : false}
    >
      <label className="error">
        {message
          ? transformErrorMessage(message, extraString, extraTo)
          : errors?.[name]?.message
          ? transformErrorMessage(errors?.[name]?.message, extraString, extraTo)
          : ""}
      </label>
    </Fade>
  );
};
export default ErrorContainer;
